import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Kicker = ({ index, label }) => (
  <div className="flex items-center gap-4 mb-8" data-testid={`kicker-${index}`}>
    <span className="font-mono text-xs tracking-[0.3em] text-[#00FF41]">{index}</span>
    <span className="h-px w-12 bg-[#00FF41]/40" />
    <span className="font-mono text-xs uppercase tracking-[0.3em] text-zinc-500">{label}</span>
  </div>
);
